import { LatLngTuple } from 'leaflet';

/** Geographic center of the U.S., somewhere around Lebanon, Kansas
 *
 * @see https://en.wikipedia.org/wiki/Geographic_center_of_the_United_States#Contiguous_United_States
 */
export const GEOGRAPHIC_CENTER_OF_US: LatLngTuple = [39.75, -99.06];
